import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { LanguageService } from '../language/language.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private http: HttpClient, private languageService: LanguageService) {}

  getMenu(){
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/menu?lang=${lang}`);
  }

 
  getMenuPagesFlat(){
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/menu/pages/flat?lang=${lang}`);
  }

  saveMenu(data: any){
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/menu/update-structure?lang=${lang}`, data);
  }

  updateMenuItem(data: any){
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/menu/update-menu-item?lang=${lang}`, data);
  }

}
